import { HttpClient } from '../HttpClient';

/**
 * Get Loan Reasons
 * @returns {Promise<any>}
 */

export const GetLoanReasons = async () => {
  try {
    const response = await HttpClient.get('/api/v1/loans/reasons');
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
};
